import React from 'react';

// ChatSidebar context indicator component - shows current page being analyzed
// Extracted from ChatSidebar.jsx lines 917-929
const ChatContextIndicator = ({ currentContext, darkMode }) => {
  // Only show when we have meaningful page analysis context
  if (!currentContext || currentContext.type !== 'page_analysis' || !currentContext.page) {
    return null;
  }

  return (
    <div className={`
      px-4 py-2 border-b text-xs flex items-center gap-2
      ${darkMode ? 'bg-gray-800 border-gray-700 text-gray-300' : 'bg-purple-50 border-purple-100 text-purple-700'}
    `}>
      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v12h8V4H6z" clipRule="evenodd" />
      </svg>
      <span className="font-medium">Analyzing:</span>
      <span className="truncate">{currentContext.page}</span>
    </div>
  );
};

export default ChatContextIndicator;
